// extracted by mini-css-extract-plugin
export default {"wrap":"Price_wrap__SekZO","annual":"Price_annual__vv9Wr"};